import { RESTAURANTS } from "./Endpoints";
import { ApiRequestInterceptor } from "../Services/apiRequest";

/** GET /restaurants/get-restaurant-by-id?restauranteId=UUID */
export const fetchRestaurantDetail = async (restauranteId) => {
    if (!restauranteId) throw new Error("restauranteId es requerido");

    const url = `${RESTAURANTS.getRestaurantById}?restauranteId=${encodeURIComponent(restauranteId)}`;
    const res = await ApiRequestInterceptor(url, "GET");

    const code = res.code ?? res.status ?? 0;
    const data = res.data ?? res; // depende de tu interceptor

    if (code === 200) return data.item;          // { item: {..., productos: [] } }
    if (code === 404) throw new Error("Restaurante no encontrado");
    throw new Error(data?.message || "Error al obtener restaurante");
};
